import React from "react"
import {FormControl, InputLabel, Select, MenuItem, Typography} from "@mui/material"
import {format} from "date-fns"

import type {CaseConversationSummary} from "@indebted/api"

function threadLabel(subject: string): string {
	return subject.trim() === "" ? "Conversation" : subject
}

function formatLastActivity(lastActivityAt: string): string {
	return format(new Date(lastActivityAt), "d MMM yyyy, HH:mm")
}

function ThreadSelector({
	summaries,
	selectedConversationID,
	onSelect,
}: {
	summaries: CaseConversationSummary[]
	selectedConversationID: string
	onSelect: (id: string) => void
}) {
	return (
		<FormControl fullWidth size="small" sx={{mb: 2}}>
			<InputLabel>Thread</InputLabel>
			<Select
				value={selectedConversationID}
				label="Thread"
				onChange={(e) => onSelect(e.target.value)}
				renderValue={(id) => {
					const selected = summaries.find((s) => s.id === id)
					return selected ? threadLabel(selected.subject) : ""
				}}
			>
				{summaries.map((s) => (
					<MenuItem key={s.id} value={s.id}>
						<Typography variant="body2" component="span">
							{threadLabel(s.subject)} · {formatLastActivity(s.lastActivityAt)}
						</Typography>
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}

export {ThreadSelector}
